import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request from '../../utils/request';
import Manipulator from '../../utils/dom/manipulator';
import Select from '../../components/Select';
import { ClassNames } from '../../utils/dom/css-classes';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';

const SELECTOR_DIV = '.js-course-booking';
const SELECTOR_TAB = '.js-course-booking-session-times';

const SELECTOR_BOOKING_BUTTON = '.p-course-details-lta-play__apply-button';
const SELECTOR_BOOKING__BACK_BUTTON = '.p-course-details__back-course-btn';
const SELECTOR_CLASSES_COUNT = '.lta-course-class-booking__classesnumber';
const SELECTOR_CLASSES_TOTALPRICE = '.lta-course-class-booking__total-price';
const SELECTOR_CLASSES_PRICECALCULATION = '.lta-course-class-booking__price-calculation';
const SELECTOR_TOTAL_SESSION = '.js-course-class-booking_timesession';
const SELECTOR_COURSE_BOOKING_BUTTON = '.js-course-booking-button';
const SELECTOR_TOTAL_COST = '.lta-course-class-booking__total-cost';

const BUTTON_EVENT = 'click';
class CourseBooking {
	constructor() {
		this._data = {};
		this._sessions = [];
		this._sessionSelectedClasses = [];
		this._persistSelectedOptions = [];
		this.init();
	}

	set selectedSessions(_sessions) {
		if (_sessions.length > 1) {
			this._sessions = Array.from(
				new Set(_sessions.filter((item) => !!item).filter((item) => item !== 'register_for_the_event'))
			);
		} else {
			this._sessions = Array.from(new Set(_sessions.filter((item) => !!item)));
		}
		this.renderDropdownError(this._sessions.length <= 0, this._dateDropDown);
		this.updateCardSelection();
		this.updateDropdownSelection();
		setTimeout(() => {
			this.selectedSessionPriceUpdate();
		}, 0);
	}

	get selectedSessions() {
		return this._sessions;
	}

	init() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_DIV);
		if (!this._wrapper) {
			return;
		}
		this._sessionTimes = SelectorEngine.findOne(SELECTOR_TAB, this._wrapper);

		this._applyButtons = SelectorEngine.find('.p-course-details-lta-play__apply-button', this._wrapper);
		this._backToCourseButton = SelectorEngine.findOne(SELECTOR_BOOKING__BACK_BUTTON, this._wrapper);

		this._classesCount = SelectorEngine.findOne(SELECTOR_CLASSES_COUNT, this._wrapper);
		this.totalPrice = SelectorEngine.findOne(SELECTOR_CLASSES_TOTALPRICE, this._wrapper);
		this.totalCost = SelectorEngine.findOne(SELECTOR_TOTAL_COST, this._wrapper);
		this.priceCalculation = SelectorEngine.findOne(SELECTOR_CLASSES_PRICECALCULATION, this._wrapper);
		this.totalSession = SelectorEngine.findOne(SELECTOR_TOTAL_SESSION, this._wrapper);
		this.courseBookingCourt = SelectorEngine.findOne(SELECTOR_COURSE_BOOKING_BUTTON, this._wrapper);
		this.ageSoftErrorElements = SelectorEngine.find('.p-course-details-lta-play__age-soft-error', this._wrapper);
		this.ageHardErrorElements = SelectorEngine.find('.p-course-details-lta-play__age-hard-error', this._wrapper);
		this.apiErrorMessages = SelectorEngine.find(
			SelectorEngine.classContainsSelector('p-course-details__booking-exceeded-error'),
			this._wrapper
		);
		this._dateDropDown = SelectorEngine.findOne('.lta-course-class-booking__dropdown .js-lta-select', this._wrapper);
		this._youthChildDropDown = SelectorEngine.findOne(
			'.lta-course-class-booking__youth-child-option .js-lta-select',
			this._wrapper
		);
		this._youthChildValue = SelectorEngine.findOne('#course-confirmation-selection', this._wrapper);

		this.requestData = {
			bookingToken: window.bookingToken
		};

		if (this._dateDropDown) {
			this.classBookingDropDownElement = Select.getInstance(this._dateDropDown) || new Select(this._dateDropDown);
			EventHandler.on(
				this.classBookingDropDownElement._selectNativeElement,
				'change',
				this.sessionDropdownHandler.bind(this)
			);
		}

		if (this._youthChildDropDown) {
			this.classBookingDropDownElements =
				Select.getInstance(this._youthChildDropDown) || new Select(this._youthChildDropDown);
			EventHandler.on(
				this.classBookingDropDownElements._selectNativeElement,
				'change',
				this.valueChangeHandler.bind(this)
			);
		}

		if (this._applyButtons) {
			for (const button of this._applyButtons) {
				EventHandler.on(button, BUTTON_EVENT, (event) => {
					this.openBookingPanel();
					this.dateSelector = SelectorEngine.findOne('#lta-select__selected-course-date-selection', this._dateDropDown);
					this.dateSelector.focus();
				});
			}
		}

		if (this._backToCourseButton) {
			EventHandler.on(this._backToCourseButton, BUTTON_EVENT, this.closeBookingPanel.bind(this));
		}
		if (this.courseBookingCourt) {
			EventHandler.on(this.courseBookingCourt, BUTTON_EVENT, this.bookCourse.bind(this));
		}
		this.isFreeEvent = this.freeEventCheck();
		this.render();
	}

	freeEventCheck() {
		let isFree = true;
		this._selectedCheckboxSession = SelectorEngine.find(
			'input[type=checkbox][name="courseSessionTimes"]',
			this._filterPanelWrapper
		);
		for (const selectedCheckbox of this._selectedCheckboxSession) {
			const dataAttributes = Manipulator.getDataAttributes(selectedCheckbox);
			if (dataAttributes?.price > 0) {
				isFree = false;
			}
		}
		return isFree;
	}

	valueChangeHandler() {
		if (this._youthChildValue.value) {
			this.renderDropdownError(false, this._youthChildDropDown);
		} else {
			this.renderDropdownError(true, this._youthChildDropDown);
		}
	}
	toggleAgeError() {
		// Hiding Soft Error.
		for (const softErrorElement of this.ageSoftErrorElements) {
			softErrorElement.classList.add('u-hidden');
		}

		// Showing Hard Error.
		for (const hardErrorElement of this.ageHardErrorElements) {
			hardErrorElement.classList.remove('u-hidden');
		}
	}

	async bookCourse() {
		try {
			if (this.ageSoftErrorElements.length) {
				this.toggleAgeError();
			}

			if (this._dateDropDown) {
				this.hideError();

				const ids = this.classBookingDropDownElement.state.selectedOptions.map(
					/*
						15472: This is a hack to get around the dual source of truth witin the Select component
						The state.selectedOptions can either be an array of `options` or `divs`.
						This picks the value off of each accordingly
					*/
					// eslint-disable-next-line prettier/prettier
					(option) => option.value || Manipulator.getDataAttribute(option, 'ssId')
				);
				this.requestData.sessionIds = ids;
			}
			if (!this._dateDropDown || this.requestData?.sessionIds?.length > 0) {
				if (this._youthChildDropDown) {
					if (this._youthChildValue.value) {
						this.requestData.courseType = this._youthChildValue.value;
						this.requestData.bookingToken =
							this.requestData.courseType === 'youth' ? window.bookingTokenYouth : window.bookingToken;
					} else {
						this.renderDropdownError(true, this._youthChildDropDown);
						return;
					}
				} else {
					this.requestData.courseType = window.courseType;
				}
				startLoadingAnimation();
				const response = await Request.post(
					'/api/cart/add-class',
					this.requestData,
					localStorage.setItem('leaveCheckoutModalUrl', window.location.href)
				);
				if (response.success) {
					window.location.href = response.redirectUrl;
				} else {
					this.showError();
				}
			} else {
				if (this._dateDropDown && this.requestData?.sessionIds?.length === 0) {
					this.renderDropdownError(true, this._dateDropDown);
				}
			}
		} catch (error) {
			this.showError();
		} finally {
			stopLoadingAnimation();
		}
	}
	renderDropdownError(isVisible, data) {
		const dropdownSelectWrapper = data.parentElement;
		const dropDownError = SelectorEngine.findOne('.lta-text-input--error', dropdownSelectWrapper);
		if (isVisible) {
			dropDownError.innerHTML = 'Please select a session';
			dropdownSelectWrapper.classList.add('is-invalid');
		} else {
			dropDownError.innerHTML = '';
			dropdownSelectWrapper.classList.remove('is-invalid');
		}
	}
	removeDropdownError() {
		const dropdownSelectWrapper = this._dateDropDown.parentElement;
		const dropDownError = SelectorEngine.findOne('.lta-text-input--error', dropdownSelectWrapper);
		dropDownError.innerHTML = '';
		dropdownSelectWrapper.classList.add('is-invalid');
	}
	toggleError(shouldShow) {
		for (const element of this.apiErrorMessages) {
			element.classList.toggle(ClassNames.Hidden, !shouldShow);
		}
	}

	showError() {
		this.toggleError(true);
	}

	hideError() {
		this.toggleError(false);
	}

	detectChange(newValues, oldValues) {
		const currentValues = newValues;
		const previousValues = oldValues;

		let recentlyChangedValue;
		let changeType;

		// Determine if the change was a selection or a deselection
		if (currentValues.length > previousValues.length) {
			// New item selected
			changeType = 'selected';
			recentlyChangedValue = currentValues.find((value) => !previousValues.includes(value));
		} else {
			// Item deselected
			changeType = 'deselected';
			recentlyChangedValue = previousValues.find((value) => !currentValues.includes(value));
		}

		return [recentlyChangedValue, changeType];
	}

	openBookingPanel() {
		this._wrapper.classList.add('is-booking-open');
		window.scrollTo(0, 0);
	}

	closeBookingPanel() {
		this._wrapper.classList.remove('is-booking-open');
	}

	render() {
		if (this._dateDropDown) {
			this._checkboxSession = SelectorEngine.find(
				'input[type=checkbox][name="courseSessionTimes"]',
				this._filterPanelWrapper
			);
			this._cardSession = SelectorEngine.find('.p-course-details-lta-play__sessiontime', this._sessionTimes);

			for (const checkbox of this._checkboxSession) {
				EventHandler.on(checkbox, BUTTON_EVENT, (event) => {
					this.cardChangeHandler(event);
				});
			}

			for (const card of this._cardSession) {
				EventHandler.on(card, BUTTON_EVENT, (event) => {
					this.selectSessionCard(event);
				});
			}
		}
	}

	selectSessionCard(event) {
		const cardCheckBox = SelectorEngine.findOne('input[type="checkbox"]', event.currentTarget);
		cardCheckBox.click();
	}

	setSelectedOptions(values, event) {
		// Get all the options of select component.
		const options = SelectorEngine.find('option', this.classBookingDropDownElement._selectNativeElement);

		// Get the selected values from select dropdown
		const selectedOptions = [];
		for (const option of options) {
			if (values.has(option.value)) {
				selectedOptions.push(option);
			}
		}
		const isErrorVisible = selectedOptions.length > 0 ? false : true;
		this.renderDropdownError(isErrorVisible, this._dateDropDown);

		// Set the dropdown values and update the view
		this.classBookingDropDownElement.selectedOptions = selectedOptions;
		this.classBookingDropDownElement.updateViewOptions();
		this.classBookingDropDownElement.renderLabel();
		event?.stopPropagation();
		return selectedOptions;
	}
	renderTotalCost() {
		if (this._sessionSelectedClasses) {
			const priceData = this._sessionSelectedClasses.map((sessionStorage) => Number(sessionStorage.price));
			const isPriceSame = priceData.every((price) => price === priceData[0]);
			const sessionLabel = this._sessionSelectedClasses.length === 1 ? 'session' : 'sessions';

			this._classesCount.innerHTML = this._sessionSelectedClasses.length;
			this.totalSession.innerHTML = this._sessionSelectedClasses.length;

			const totalPrice = priceData.reduce((lastPrice, price) => lastPrice + price, 0).toFixed(2);

			this.totalPrice.innerHTML = !this.isFreeEvent ? totalPrice : 'Free';

			if (isPriceSame && (priceData[0] === 0 || priceData?.length === 0) && this.isFreeEvent) {
				this.priceCalculation.innerHTML = `<span class="lta-course-class-booking__classesnumber">${this._sessionSelectedClasses.length}</span> ${sessionLabel}`;
			} else {
				this.priceCalculation.innerHTML =
					isPriceSame && !this.isFreeEvent
						? `<span class="lta-course-class-booking__price">£<span class="lta-course-class-booking__price-number">
						${(priceData[0] || 0).toFixed(2)}
					   </span>
					   </span> x <span class="lta-course-class-booking__classesnumber">${this._sessionSelectedClasses.length}</span> 
					   ${sessionLabel}`
						: 'prices vary';
			}
		}
	}

	sessionDropdownHandler(event) {
		const selectedItems = Array.from(event.target.selectedOptions).map((item) => item.value);
		const [item, changeEvent] = this.detectChange(selectedItems, this.selectedSessions);
		if (changeEvent === 'selected' && item === 'register_for_the_event') {
			this.selectedSessions = ['register_for_the_event'];
		} else {
			this.selectedSessions = selectedItems;
		}
	}

	cardChangeHandler(event) {
		if (event.target.checked) {
			if (event.target.value !== 'register_for_the_event') {
				this.selectedSessions = [...this.selectedSessions, event.target.value];
			} else {
				this.selectedSessions = ['register_for_the_event'];
				this.updateCardSelection();
			}
		} else {
			this.selectedSessions = this.selectedSessions.filter((item) => item !== event.target.value);
		}
		event.stopPropagation();
	}

	updateCardSelection() {
		const checkboxes = SelectorEngine.find('input[type=checkbox][name="courseSessionTimes"]', this._filterPanelWrapper);
		for (let checkbox of checkboxes) {
			checkbox.checked = this.selectedSessions?.includes(checkbox.value);
		}
	}

	updateDropdownSelection() {
		const selectedOptions = [];
		const options = SelectorEngine.find('option', this.classBookingDropDownElement._selectNativeElement);
		for (const option of options) {
			if (this.selectedSessions.includes(option.value)) {
				selectedOptions.push(option);
			}
		}
		this.classBookingDropDownElement.selectedOptions = selectedOptions;
		this.classBookingDropDownElement.updateViewOptions();
		this.classBookingDropDownElement.renderLabel();
	}

	selectedSessionPriceUpdate() {
		this._selectedCheckboxSession = SelectorEngine.find(
			'input[type=checkbox][name="courseSessionTimes"]:checked',
			this._filterPanelWrapper
		);
		this._sessionSelectedClasses = [];
		for (const selectedCheckbox of this._selectedCheckboxSession) {
			this._sessionSelectedClasses.push(Manipulator.getDataAttributes(selectedCheckbox));
		}
		this.renderTotalCost();
	}
}

const globalCourseBooking = new CourseBooking();
export default globalCourseBooking;
